<template>
    <Popup ref="popup" :minWidth="400" :isShowHeader="false" :isShowClose="false" :is-show="isVisible"
        @closed="closePopup" title="Thông báo" :height="$app.isMobile ? '100%' : '60%'"
        :width="$app.isMobile ? '100%' : '60%'" :isShowOverlay="false">
        <template slot="header">
            <h2
                class="w-full bg-brand p-3 text-center text-yellow-500 font-bold text-[16px] tracking-wide sticky top-0 z-50 grid grid-cols-3 items-center shadow-md border-b border-brand" style="background-color: var(--color-brand);">
                <div class="flex justify-start space-x-2 pl-2">
                    <el-tooltip class="item" effect="dark" content="Tải file" placement="top">
                        <button class="w-9 h-9 rounded-full bg-white/10 hover:bg-white text-white/90 hover:text-brand transition-colors flex items-center justify-center cursor-pointer shadow-sm border border-white/20" @click="downloadFile(selectedFile)">
                            <font-awesome-icon :icon="['fas', 'download']" class="text-[14px]" />
                        </button>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="Mở rộng file" placement="top">
                        <button class="w-9 h-9 rounded-full bg-white/10 hover:bg-white text-white/90 hover:text-brand transition-colors flex items-center justify-center cursor-pointer shadow-sm border border-white/20" @click="openInNewTab(selectedFile)">
                            <font-awesome-icon :icon="['fas', 'expand-arrows-alt']" class="text-[14px]" />
                        </button>
                    </el-tooltip>
                </div>
                <div class="text-center flex items-center justify-center h-full">
                    File đính kèm
                </div>
                <div class="flex justify-end pr-2">
                    <button @click="closePopup()"
                        class="w-9 h-9 rounded-full bg-white/10 hover:bg-red-500 text-white/90 hover:text-white transition-colors flex items-center justify-center cursor-pointer shadow-sm border border-white/20">
                        <font-awesome-icon :icon="['fas', 'xmark']" class="text-[16px]" />
                    </button>
                </div>
            </h2>
        </template>

        <template slot="body">
            <div class="bg-white">
                <div v-if="isImage(selectedFile)" class="h-min p-[10px]">
                    <img :src="`https://s3.ap-southeast-1.amazonaws.com/guta.content/${selectedFile.hash}${selectedFile.ext}`"
                        alt="Preview" class="rounded-lg shadow-md m-auto w-full md:w-[60%]" />
                </div>
                <iframe class="w-full h-[95vh]" v-else-if="isPDF(selectedFile)"
                    :src="`https://docs.google.com/gview?embedded=true&url=https://s3.ap-southeast-1.amazonaws.com/guta.content/${selectedFile.hash}${selectedFile.ext}`"
                    frameborder="0"></iframe>
                <iframe v-else class="w-screen h-[95vh]"
                    :src="`https://view.officeapps.live.com/op/embed.aspx?src=https://s3.ap-southeast-1.amazonaws.com/guta.content/${selectedFile.hash}${selectedFile.ext}`"
                    frameborder="0"></iframe>
            </div>
        </template>

    </Popup>
</template>

<script>
const API_URL = process.env.VUE_APP_API_URL
const IMG_URL = process.env.VUE_APP_IMG_URL
import Popup from '../component/common/Popup.vue';
import { saveAs } from 'file-saver';
export default {
    components: {
        Popup
    },
    props: {
        isShow: {
            type: Boolean,
            default: false,
        },
        selectedFile: {
            type: Object,
            default: () => { }
        }
    },
    data() {
        return {
            isVisible: false,
            billcode: ''
        };
    },

    computed: {

    },
    mounted() {
        if (this.isShow) {
            this.isVisible = true
        }
    },
    methods: {
        openInNewTab(file) {
            const baseUrl = `https://s3.ap-southeast-1.amazonaws.com/guta.content/${file.hash}${file.ext}`;
            if (this.isImage(file)) {
                window.open(baseUrl, "_blank");
                return;
            } else if (this.isPDF(file)) {
                const pdfUrl = `https://docs.google.com/gview?embedded=true&url=${baseUrl}`;
                window.open(pdfUrl, "_blank");
                return;
            }
            const viewUrl = `https://view.officeapps.live.com/op/embed.aspx?src=${baseUrl}`;
            window.open(viewUrl, "_blank");
        },

        // async downloadFile(file) {
        //     // Thêm response-content-disposition để ép trình duyệt tải xuống
        //     const url = `https://s3.ap-southeast-1.amazonaws.com/guta.content/${file.hash}${file.ext}`;

        //     try {
        //         // Tạo thẻ a để tải file trực tiếp mà không cần fetch blob
        //         const link = document.createElement('a');
        //         link.href = url;
        //         link.download = file.name || `${file.hash}${file.ext}`;
        //         document.body.appendChild(link);
        //         link.click();
        //         document.body.removeChild(link);
        //     } catch (err) {
        //         console.error(err);
        //         alert("Không thể tải file.");
        //     }
        // },

        async downloadFile(file) {
            const url = `https://s3.ap-southeast-1.amazonaws.com/guta.content/${file.hash}${file.ext}`;
            try {
                const res = await fetch(url, { mode: 'cors' }); // đảm bảo CORS ok
                const blob = await res.blob();
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = file.name || `${file.hash}${file.ext}`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(link.href);
            } catch (err) {
                console.error(err);
                alert("Không thể tải file.");
            }
        },



        isSupportedFile(url) {
            return /\.(pdf|docx?|xlsx?)$/i.test(url);
        },
        closePopup() {
            this.isVisible = false
            setTimeout(() => {
                this.$emit('closed');
            }, 200);
        },
        fortmatUrl(url) {
            const fullUrl = IMG_URL + url
            return fullUrl
        },
        isImage(file) {
            return file && file.mime && file.mime.startsWith("image/");
        },
        isPDF(file) {
            return file && file.mime === "application/pdf";
        },
        isDoc(file) {
            return file && (file.mime === "application/msword" || file.mime === "application/vnd.openxmlformats-officedocument.wordprocessingml.document");
        },
        isExcel(file) {
            return file && file.mime === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
    }
};
</script>

<style scoped>
@keyframes popupFadeIn {
    0% {
        opacity: 0;
        transform: translateY(10px);
    }

    100% {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes popupFadeOut {
    0% {
        opacity: 1;
        transform: translateY(0);
    }

    100% {
        opacity: 0;
        transform: translateY(10px);
    }
}

.animate-popupFadeIn {
    animation: popupFadeIn 0.5s forwards;
}

.animate-popupFadeOut {
    animation: popupFadeOut 0.5s forwards;
}
</style>